import React, { useCallback } from 'react';
import { IconArrowLeft } from '@tabler/icons-react';

import useTranslate from '@src/i18n/useTranslate';

import { useCheckoutNavigation } from './CheckoutFlowContext';
import { resolveCheckoutHeaderTitle } from './core/resolveCheckoutHeaderTitle';
import { CheckoutBackButton, CheckoutHeaderRow, CheckoutHeaderTitle } from './styles';

export const CheckoutHeader = () => {
  const { i18n } = useTranslate();
  const { mode, authSubStep, goBack, canGoBack, bootstrapping } = useCheckoutNavigation();
  const titleKey = resolveCheckoutHeaderTitle(mode, authSubStep, bootstrapping);

  const handleBackClick = useCallback(() => {
    goBack();
  }, [goBack]);

  return (
    <CheckoutHeaderRow data-testid='checkout-header'>
      {canGoBack ? (
        <CheckoutBackButton type='button' onClick={handleBackClick} aria-label={i18n('checkout_back')}>
          <IconArrowLeft size={20} aria-hidden />
        </CheckoutBackButton>
      ) : null}
      <CheckoutHeaderTitle>{i18n(titleKey)}</CheckoutHeaderTitle>
    </CheckoutHeaderRow>
  );
};

export default CheckoutHeader;
